import React from 'react';

import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TFilterItem } from '@features/JournalEventsFilters/model/types';
import { Icon, Select } from '@shared/ui';

import { IFormFieldProps } from '../../../model/types';
import cls from '../EventJournalModal.module.css';

export const SelectEstimatesField = ({
    estimates,
    control,
    isDisabled,
}: IFormFieldProps & { estimates: TFilterItem[] }) => {
    const { t } = useTranslation();
    return (
        <Controller
            key="selectEstimates"
            name="selectEstimates"
            control={control}
            render={({ field }) => (
                <Select
                    {...field}
                    isSmartPosition
                    options={estimates}
                    placeholder={t('JournalEvents.EventJournalModal.SelectEstimates.Placeholder')}
                    onChange={(value) => {
                        field.onChange(value ?? null);
                        field.value = Number(value);
                    }}
                    id="selectEstimates"
                    needSearch
                    classes={cls.SelectWrapper}
                    leftIcon={
                        <span className={cls.EstimateIconContainer}>
                            <Icon iconName="taskEstimate" />{' '}
                        </span>
                    }
                    selectRootClassName={cls.SelectRoot}
                    isDisabled={isDisabled}
                    noSelectOption={{ value: null, label: t('select.notPicked') }}
                />
            )}
        />
    );
};
